<template>
  <Teleport to="body">
  <div class="modal fade schedule-editor-modal" id="kt_modal_event" data-bs-keyboard="false"
       data-bs-backdrop="static" tabindex="-1" aria-hidden="true" aria-labelledby="schedule-editor-title">
    <div class="modal-dialog modal-dialog-centered schedule-editor-modal__dialog">
      <div class="modal-content">

        <div class="modal-header schedule-editor-modal__header">
          <h2 id="schedule-editor-title" data-kt-calendar="title">
            <template v-if="(isProgramMode && !scheduleEdit) || showProgramView">
              Atendimento Multi Profissional
            </template>
            <template v-else>
              {{ rescheduling ? 'Reagendar' : (scheduleEdit ? 'Agendamento' : 'Novo agendamento') }}
            </template>
            <span class="badge badge-light-success" v-if="scheduleEdit?.sched_online">
                Atendimento Online
            </span>
            <ScheduleRecurrenceBadge
              class="ms-2"
              v-if="scheduleEdit?.sched_recur_id && !showProgramView"
              :session="scheduleEdit?.sched_recur_session"
              :total="scheduleEdit?.sched_recur_total"
              @open="openRecurrenceSessions = true"
            />
            <span
              class="ms-3 fs-7 fw-normal d-inline-flex align-items-center gap-2"
              v-if="scheduleEdit?.id_sched_program"
              style="vertical-align: middle;"
            >
              <input
                class="form-check-input m-0"
                type="checkbox"
                id="program_view_toggle"
                v-model="showProgramView"
                style="width: 1.1rem; height: 1.1rem; margin-top: 0;"
              >
              <label class="form-check-label mb-0 lh-1" for="program_view_toggle">
                Ver programa
              </label>
            </span>

            <span class="flex-grow-1 me-2 text-center">
                <span v-if="scheduleEdit?.is_sched_finished" class="badge badge-success fw-bolder mx-2">
                    Finalizado {{ scheduleEdit?.finished_at_br }}
                </span>
                <span
                  v-else-if="scheduleEdit?.is_sched_in_progress"
                  class="badge badge-light-success fw-bolder mx-2">
                    Em andamento
                </span>
                <span v-else-if="scheduleEdit?.is_sched_confirmed"
                      class="badge badge-light-primary fw-bolder mx-2">
                    Confirmado {{ scheduleEdit?.confirmed_at_br }}
                </span>
                <span v-else-if="scheduleEdit?.is_sched_canceled"
                      class="badge badge-danger fw-bolder mx-2">
                    Cancelado {{ scheduleEdit?.canceled_at_br }}
                </span>
                <span v-else-if="scheduleEdit?.is_return"
                      class="badge badge-warning fw-bolder mx-2">
                    Retorno
                </span>
            </span>
          </h2>
          <button type="button" class="schedule-editor-modal__close"
                  @click="$emit('onCloseModal')" data-bs-dismiss="modal" aria-label="Fechar">
            <i class="bi bi-x-lg" aria-hidden="true"></i>
          </button>
        </div>
        <div v-if="!scheduleEdit && !rescheduling && professionals?.length > 1" class="schedule-editor__mode">
          <span id="schedule-mode-label" class="schedule-editor__mode-label">Tipo de agendamento</span>
          <div class="schedule-editor__mode-options" role="group" aria-labelledby="schedule-mode-label">
            <button type="button" class="schedule-editor__mode-option" :class="{ 'is-active': !isProgramMode }"
                    :aria-pressed="!isProgramMode" @click="isProgramMode = false">
              <i class="bi bi-person" aria-hidden="true"></i> Individual
            </button>
            <button type="button" class="schedule-editor__mode-option" :class="{ 'is-active': isProgramMode }"
                    :aria-pressed="isProgramMode" @click="isProgramMode = true">
              <i class="bi bi-people" aria-hidden="true"></i> Multiprofissional
            </button>
          </div>
        </div>
        <div class="modal-body pt-1">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <button class="nav-link active" id="data-schedule-modal-tab"
                      data-bs-toggle="tab" data-bs-target="#data-schedule-modal"
                      type="button" role="tab" aria-controls="home" aria-selected="true">
                Dados
              </button>
            </li>
            <li class="nav-item" v-show="scheduleEdit != null && showHistory">
              <button class="nav-link" id="data-history-modal-tab"
                      data-bs-toggle="tab" data-bs-target="#data-history-modal"
                      type="button" role="tab" aria-controls="history" aria-selected="false">
                Histórico
              </button>
            </li>
            <li class="nav-item" v-show="scheduleEdit != null && showHistory">
              <button class="nav-link" id="data-notifications-modal-tab"
                      data-bs-toggle="tab" data-bs-target="#data-notifications-modal"
                      type="button" role="tab" aria-controls="history" aria-selected="false">
                Mensagens
              </button>
            </li>
            <li class="nav-item" v-show="scheduleEdit != null && showHistory">
              <button class="nav-link" id="data-files-modal-tab"
                      data-bs-toggle="tab" data-bs-target="#data-files-modal"
                      type="button" role="tab" aria-controls="files" aria-selected="false">
                Arquivos
              </button>
            </li>
            <li class="nav-item" v-show="scheduleEdit != null && showHistory">
              <button class="nav-link" id="data-pre-schedule-modal-tab"
                      data-bs-toggle="tab" data-bs-target="#data-pre-schedule-modal"
                      type="button" role="tab" aria-controls="pre-schedule" aria-selected="false">
                Pré-consulta
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active"
                 id="data-schedule-modal" role="tabpanel"
                 aria-labelledby="home-tab">

              <ModalScheduleProgram
                v-if="isProgramMode && !scheduleEdit"
                @saved="onProgramSaved"
              />
              <ModalScheduleProgram
                v-else-if="showProgramView && scheduleEdit?.id_sched_program"
                :key="`program-view-${scheduleEdit.id_sched_program}`"
                :readonly="true"
                :program-id="scheduleEdit.id_sched_program"
              />
              <form class="form schedule-editor" @submit.prevent="onSubmit" v-else>
                <div class="schedule-editor__main">
                <div class="row g-4 schedule-editor__fields">
                  <div class="col-12 schedule-editor__section-title"><i class="bi bi-clipboard2-pulse" aria-hidden="true"></i> Atendimento</div>

                  <div class="col-md-5">
                    <div class="fv-row">
                      <label class="fs-6 fw-bold mb-2" for="id_prof">
                        Profissional
                      </label>
                      <SelectUbbi
                        class="form-control form-control-solid"
                        :options="professionals"
                        searchable
                        :disabled="scheduleEdit != null && this.rescheduling"
                        @change="onChangeProf"
                        v-model="form.id_prof"
                        optionLabel="prof_name"
                        optionValue="id_prof"
                        id="id_prof"
                        placeholder="Profissional"
                      />
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="fv-row">
                      <label class="fs-6 required fw-bold mb-2">Especialidade</label>
                      <SelectUbbi
                        class="form-control form-control-solid"
                        :options="specialties"
                        searchable
                        v-model="form.id_spec"
                        optionLabel="spec_name"
                        optionValue="id_spec"
                        @change="loadDatesAvailabilityToSchedule(form.sched_date)"
                        id="id_spec"
                        placeholder="Especialidades"
                        :disabled="this.rescheduling"
                      />
                    </div>
                  </div>

                  <div class="col-md-3 mb-3">
                    <div class="fv-row">
                      <label class="fs-6 fw-bold mb-2">Forma de recebimento</label>
                      <SelectUbbi
                        class="form-control form-control-solid"
                        :options="paymentMethods"
                        v-model="form.id_paymeth"
                        optionLabel="paymeth_name"
                        optionValue="id_paymeth"
                        searchable
                        @change="loadDatesAvailabilityToSchedule(form.sched_date)"
                        id="id_paymeth"
                        placeholder="Forma de recebimento"
                        :disabled="this.rescheduling"
                      />
                    </div>
                  </div>

                  <div class="col-12 schedule-editor__section-title schedule-editor__section-title--divided"><i class="bi bi-person" aria-hidden="true"></i> Paciente</div>
                  <div class="col-md-6">
                    <div class="fv-row">
                      <div class="d-flex align-items-center justify-content-between mb-2">
                        <label class="fs-6 fw-bold required mb-0">Paciente</label>
                        <a v-if="currentPatientId" href="#"
                                title="Editar paciente"
                                @click.prevent="openModalEditPatient">
                          <i class="bi bi-pen"></i> Editar
                        </a>
                      </div>
                      <SearchPatient v-model="form.sched_patient_name"
                                     :value="form.sched_patient_name"
                                     :disabled="scheduleEdit != null && this.rescheduling"
                                     :professionalId="parseInt(form.id_prof)"
                                     :key="form.id_prof + '-' + uniqueKey"
                                     @onInput="onClickSearchedPatient"
                                     @onClick="onClickSearchedPatient"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="fv-row">
                      <PatientIdentityFields :form="form" :show-nationality="false" cpf-field="sched_patient_cpf" :disabled="this.rescheduling" :allow-select="!scheduleEdit" @select="onClickSearchedPatient" />
                    </div>
                  </div>

                  <div :class="form.is_foreign ? 'col-md-4' : 'col-md-6'">
                    <div class="fv-row">
                      <label class="fs-6 required fw-bold mb-2">Data de nascimento</label>
                      <input type="text" class="form-control form-control-solid"
                             v-mask="'##/##/####'" required
                             placeholder="DD/MM/YYYY" v-model="form.sched_patient_birthdate"
                             :disabled="this.rescheduling"/>
                    </div>
                  </div>
                  <div :class="form.is_foreign ? 'col-md-4' : 'col-md-6'">
                    <div class="fv-row">
                      <label class="fs-6 required fw-bold mb-2">Telefone</label>
                      <input type="text" class="form-control form-control-solid"
                             v-mask="['(##) ####-####', '(##) #####-####']" required
                             placeholder="(99) 9 9999-9999" v-model="form.sched_patient_phone"
                             :disabled="this.rescheduling"/>
                    </div>
                  </div>
                  <div v-if="form.is_foreign" class="col-md-4">
                    <PatientNationalityField :form="form" :disabled="rescheduling" />
                  </div>
                  <div class="col-12 schedule-editor__section-title schedule-editor__section-title--divided"><i class="bi bi-card-text" aria-hidden="true"></i> Detalhes do agendamento</div>
                  <div class="col-md-4">
                    <div class="fv-row">
                      <label class="fs-6 required fw-bold mb-2">Tipo</label>
                      <SelectUbbi
                        class="form-control form-control-solid"
                        v-model="form.sched_type"
                        :options="scheduleTypeOptions"
                        option-label="name"
                        option-value="code"
                        placeholder="Tipo"
                        :disabled="this.rescheduling"
                      />
                    </div>
                  </div>

                  <div class="col-md-4" v-show="allowInsurance()">
                    <div class="fv-row">
                      <label class="fs-6 fw-bold mb-2">Convênio</label>
                      <SelectUbbi
                        class="form-control form-control-solid"
                        :options="insurances"
                        searchable
                        v-model="form.id_insurance"
                        optionLabel="insurance_name"
                        optionValue="id_insurance"
                        :filter-fields="['insurance_name', 'trading_name']"
                        id="id_insurance"
                        placeholder="Convênio"
                        :disabled="this.rescheduling"
                      >
                        <template #option="{ option }">
                          {{ insuranceLabel(option) }}
                        </template>
                        <template #value="{ option }">
                          {{ option ? insuranceLabel(option) : 'Convênio' }}
                        </template>
                      </SelectUbbi>
                    </div>
                  </div>

                  <div class="col-md-4" v-if="!allowInsurance() && scheduleEdit?.policy_cancel_name != null">
                    <div class="fv-row">
                      <label class="fs-6 fw-bold mb-2">
                        Política de cancelamento
                        <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-html="true"
                           :title="scheduleEdit?.policy_cancel_desc"
                           :data-bs-title="scheduleEdit?.policy_cancel_desc"></i>
                      </label>
                      <select class="form-control form-control-solid" disabled>
                        <option :value="scheduleEdit?.policy_cancel_name">{{scheduleEdit?.policy_cancel_name}}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div v-show="allowInsurance()">
                      <label class="fs-6 fw-bold mb-2">Número da guia</label>
                      <input type="text" class="form-control form-control-solid"
                             maxlength="100"
                             placeholder="Ex. 1234657" v-model="form.sched_guide_number"
                             :disabled="this.rescheduling"/>
                    </div>

                    <div v-if="isInPerson()">
                      <label class="fs-6 fw-bold mb-2">Valor</label>
                      <input type="number" class="form-control form-control-solid"
                             placeholder="Ex. 250"
                             v-model.number="form.sched_value"
                             step="0.01"
                             min="0" />
                    </div>

                  </div>

                  <div class="col-md-12">
                    <label class="fs-6 fw-bold mb-2">Observação</label>
                    <textarea class="form-control form-control-solid"
                              v-model="form.sched_obs" rows="3"
                              placeholder="Observação do agendamento"
                              :disabled="this.rescheduling"/>
                  </div>

                  <div class="col-12" v-show="scheduleEdit == null && curentWaitingList == null">
                    <div class="row g-3 schedule-editor__waiting">
                      <div class="col-12">
                        <div class="form-check schedule-editor__check">
                          <input class="form-check-input" type="checkbox"
                                 v-model="form.add_waiting_list" id="add_waiting_list">
                          <label class="form-check-label" for="add_waiting_list">
                            Adicionar paciente na lista de espera?
                          </label>
                        </div>
                      </div>
                      <template v-if="form.add_waiting_list">
                        <div class="col-md-6">
                          <label class="fs-6 fw-bold mb-2 required">Data de limite de espera:</label>
                          <input type="text" class="form-control form-control-solid"
                                 required v-mask="'##/##/####'"
                                 title="Até que dia o paciente permanecerá na lista de espera?"
                                 placeholder="DD/MM/YYYY" v-model="form.wl_wait_at"/>
                        </div>
                        <div class="col-md-6">
                          <label class="fs-6 fw-bold mb-2">Observação da lista de espera:</label>
                          <textarea class="form-control form-control-solid" placeholder="Ex. Paciente com dor"
                                    v-model="form.wl_obs" rows="1"></textarea>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div class="col-md-12 mt-5" v-if="patient_last_schedule">
                    <div class="alert-info rounded p-2">
                      Última consulta: {{this.date(patient_last_schedule).format('DD/MM/YYYY')}}
                    </div>
                  </div>
                </div>

                <div class="row mt-3" v-if="scheduleEdit != null && isScheduleDateMoreThanToday() && !rescheduling">
                  <div class="col-md-8">
                    <BtnArriveSchedule
                      @onArriveSchedule="arriveSchedule"
                      :scheduleEdit="scheduleEdit"
                      classes="mb-2"
                      :btnText="scheduleEdit?.sched_arrive ? 'Estornar chegada' : 'Confirmar chegada'"
                    />
                    <BtnCancelSchedule
                      @onCancelSchedule="() => {
                        this.$emit('onCloseModal');
                        this.$emit('onScheduleCancel');
                        this.toggleModal();
                      }"
                      @onUncancelSchedule="() => {
                        this.$emit('onCloseModal');
                        this.$emit('onScheduleCancel');
                        this.toggleModal();
                      }"
                      :scheduleEdit="scheduleEdit"
                    />
                    <button type="button"
                            v-if="['AG', 'CO'].includes(scheduleEdit?.sched_status) && !scheduleEdit?.sched_arrive"
                            @click="confirmSchedule(scheduleEdit?.sched_status)"
                            class="btn btn-primary btn-flex me-2 mb-2">
                      {{
                        scheduleEdit?.is_sched_confirmed ? 'Estornar confirmação' : 'Confirmar'
                      }}
                    </button>
                    <BtnFinishOrReOpenSchedule
                      :scheduleEdit="scheduleEdit"
                      :classes="(scheduleEdit?.is_sched_finished ? 'btn-outline btn-outline-info' : 'btn-info')"
                      :btnText="(scheduleEdit?.is_sched_finished ? 'Reabrir atendimento' : 'Finalizar atendimento')"
                      @onFinishSchedule="onFinishSchedule"
                      @onReopenSchedule="onReopenSchedule"
                    />
                    <BtnStartAttendanceSchedule
                      :scheduleEdit="scheduleEdit"
                      :btnText="scheduleEdit.sched_start ? 'Continuar atendimento' : 'Iniciar atendimento'"
                      @onStartAttendance="onStartAttendance"
                    />
                    <button type="button"
                            v-if="['CM'].includes(scheduleEdit?.sched_status)"
                            @click="this.rescheduling = true"
                            class="btn btn-primary btn-flex me-2 mb-2">
                      Reagendar
                    </button>
                  </div>
                  <div class="col-md-4 text-lg-end">
                    <button type="button" v-if="scheduleEdit != null && canGenerateGuide() && !scheduleEdit?.has_tiss_guide && hasPermission('Create TISS Guide')"
                            @click="generateGuide()"
                            title="Emitir guia"
                            :disabled="generatingGuide"
                            class="btn btn-success me-2 mb-2">
                      <i class="bi bi-clipboard-data me-1"></i>
                      {{ generatingGuide ? 'Emitindo...' : 'Emitir Guia' }}
                    </button>
                    <button type="button" v-if="scheduleEdit != null && canGenerateNfse() && !scheduleEdit?.has_nfse && hasPermission('Generate NFSe')"
                            @click="generateNfse()"
                            title="Gerar nota fiscal"
                            :disabled="generatingNfse"
                            class="btn btn-success me-2 mb-2">
                      <i class="bi bi-file-earmark-text me-1"></i>
                      {{ generatingNfse ? 'Gerando...' : '' }}
                    </button>
                    <div v-if="scheduleEdit?.has_tiss_guide && scheduleGuide" class="btn-group me-2 mb-2">
                      <button type="button"
                              class="btn btn-info dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              :disabled="loadingGuideActions">
                        <i class="bi bi-clipboard-data me-1"></i>
                        Guia
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          <a class="dropdown-item" href="#" @click.prevent="openGuidePdf">
                            <i class="bi bi-eye me-2"></i>
                            Abrir em nova aba
                          </a>
                        </li>
                        <li v-if="canReopenGuidePix()">
                          <a class="dropdown-item" href="#" @click.prevent="openGuidePixCharge">
                            <i class="bi bi-qr-code me-2"></i>
                            Reabrir QR Code Pix
                          </a>
                        </li>
                        <li v-if="canOpenGuideBankSlip()">
                          <a class="dropdown-item" href="#" @click.prevent="openGuideBankSlip">
                            <i class="bi bi-file-earmark-pdf me-2"></i>
                            Abrir boleto
                          </a>
                        </li>
                        <li v-if="canCancelGuide()">
                          <a class="dropdown-item text-danger" href="#" @click.prevent="cancelGuide">
                            <i class="bi bi-x-circle me-2"></i>
                            Cancelar guia
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div v-if="scheduleEdit?.has_nfse && scheduleNfse" class="btn-group me-2 mb-2">
                      <button type="button"
                              class="btn btn-success dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              :disabled="loadingNfseActions">
                        <i class="bi bi-file-earmark-pdf me-1"></i>
                        NFSe
                      </button>
                      <ul class="dropdown-menu">
                        <li v-if="canDownloadDanfse">
                          <a class="dropdown-item" href="#" @click.prevent="openDanfse">
                            <i class="bi bi-eye me-2"></i>
                            Abrir em nova aba
                          </a>
                        </li>
                        <li v-if="canDownloadDanfse">
                          <a class="dropdown-item" href="#" @click.prevent="downloadDanfse">
                            <i class="bi bi-download me-2"></i>
                            Baixar PDF
                          </a>
                        </li>
                        <li v-if="canDownloadDanfse"><hr class="dropdown-divider"></li>
                        <li v-if="canDownloadDanfse">
                          <a class="dropdown-item" href="#" @click.prevent="showEmailModal">
                            <i class="bi bi-envelope me-2"></i>
                            Enviar por e-mail
                          </a>
                        </li>
                        <li v-if="!canDownloadDanfse">
                          <span class="dropdown-item-text text-muted">
                            <i class="bi bi-info-circle me-2"></i>
                            Emita a NFSe para gerar a DANFSE
                          </span>
                        </li>
                      </ul>
                    </div>
                    <button v-else-if="scheduleEdit?.has_nfse"
                            type="button"
                            disabled
                            title="Carregando NFSe..."
                            class="btn btn-success me-2 mb-2">
                      <i class="bi bi-hourglass-split"></i>
                    </button>
                    <BtnAddWaitingListSchedule :schedule-edit="scheduleEdit"/>
                  </div>
                </div>

                <div class="row mt-5" v-if="rescheduling">
                  <div class="col-md-12 text-center">
                    <h3 class="fw-bold border p-3 bg-primary rounded text-white">
                      Selecione a data para reagendamento
                    </h3>
                  </div>
                </div>

                <br>

                <div class="row mb-4" v-if="professionalAttendsOnline && !rescheduling">
                  <div class="col-md-12">
                    <div class="form-check schedule-editor__check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="avail_online"
                        v-model="form.avail_online"
                        @change="onToggleAvailOnline"
                        :disabled="scheduleEdit != null && !isScheduleDateMoreThanToday()"
                      >
                      <label class="form-check-label" for="avail_online">
                        Atendimento online (teleconsulta)
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4" v-if="form.avail_online && !rescheduling">
                  <div class="col-md-12">
                    <div class="card online-participants-card">
                      <div class="card-body">
                        <div class="online-participants__header">
                          <div class="online-participants__intro">
                            <h5 class="online-participants__title">Participantes extras da chamada</h5>
                            <p class="text-muted small mb-0">
                              O paciente já participa da teleconsulta. Convide outras pessoas por e-mail.
                            </p>
                          </div>
                          <button
                            type="button"
                            class="btn btn-sm btn-light-primary online-participants__add"
                            @click="openParticipantModal"
                          >
                            <i class="bi bi-person-plus" aria-hidden="true"></i><span>Adicionar participante</span>
                          </button>
                        </div>

                        <div v-if="form.participants.length === 0" class="text-muted small">
                          Nenhum participante adicional cadastrado.
                        </div>

                        <ul v-else class="list-group list-group-flush">
                          <li
                            v-for="(participant, index) in form.participants"
                            :key="participant.id_schedule_participant || participant.email || index"
                            class="list-group-item d-flex justify-content-between align-items-center px-0"
                          >
                            <span>{{ participant.email }}</span>
                            <div class="d-flex gap-2">
                              <button
                                type="button"
                                class="btn btn-sm btn-light-primary"
                                title="Copiar link da chamada"
                                @click="copyParticipantLink(participant)"
                              >
                                <i class="bi bi-clipboard"></i>
                              </button>
                              <button
                                type="button"
                                class="btn btn-sm btn-light-danger"
                                title="Remover participante"
                                @click="removeParticipant(index)"
                              >
                                <i class="bi bi-trash"></i>
                              </button>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                </div>
                <aside class="schedule-editor__availability" aria-label="Data e horário">
                <h3 class="schedule-editor__section-title"><i class="bi bi-calendar3" aria-hidden="true"></i> Data e horário</h3>
                <div class="row g-3 schedule-editor__date-fields">
                  <div :class="form.is_recurrence ? 'col-md-5' : 'col-md-9'">
                    <div class="flex flex-wrap gap-3 p-fluid">
                      <div class="flex-auto">
                        <div class="row">
                          <div class="col-md-6">
                            <label class="fs-6 fw-bold mb-2 required">Data</label>
                          </div>
                          <div class="col-md-6 text-end" v-if="form.sched_date != null && scheduleEdit == null">

                            <input class="form-check-input" type="checkbox" value=""
                                   id="is_recurrence" v-model="form.is_recurrence">
                            <label class="form-check-label ms-2" for="is_recurrence">
                              Recorrência
                            </label>

                          </div>
                        </div>
                        <Calendar v-model="form.sched_date" dateFormat="yy/mm/dd" inline
                                  :disabled="!isScheduleDateMoreThanToday()"
                                  :manualInput="false"
                                  @dateSelect="onSelectDate"
                                  @monthChange="onChangeMonth">
                          <template #date="slotProps">
                            <div v-if="dateIsAvailabilityToSchedule(slotProps.date)">
                              <div
                                :style="{ color: getTextColor(slotProps.date), backgroundColor: getBackgoundColor(slotProps.date), padding: '1px', borderRadius: '50%', width: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center'}"
                                :title="`${getEventRate(slotProps.date)}%`">
                                <strong>{{ slotProps.date.day }}</strong>
                              </div>
                            </div>
                            <div v-else>
                              <i style="pointer-events: none; cursor: not-allowed">
                                {{ slotProps.date.day }}
                              </i>
                            </div>
                          </template>
                        </Calendar>

                        <div class="col-md-6">
                          <div class="d-flex justify-content-start flex-wrap gap-1 pt-4">
                            <BusyRateLegend/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="form.is_recurrence ? 'col-md-2' : 'col-md-3'">
                    <div class="schedule-editor__time-heading">
                    <div class="form-label required mb-0">
                      Hora
                      <div v-if="locations && locations.length > 0 && !form.avail_online" class="btn-group d-inline ms-2" ref="locationDropdown">
                        <button type="button"
                                class="btn btn-link p-0 text-primary text-decoration-none border-0 shadow-none"
                                :id="'locationDropdownBtn'"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style="font-size: inherit; vertical-align: baseline;"
                                :class="{'text-danger': form.id_place_location === ''}">
                          (
                          <i class="bi bi-geo-alt-fill"></i>
                          <span class="ms-1">{{ getCurrentLocationDisplay() }}</span>
                          )
                        </button>
                        <ul class="dropdown-menu shadow-lg" style="min-width: 320px; padding: 0.5rem 0; border-radius: 0.5rem;">
                          <li>
                            <button class="dropdown-item d-flex align-items-start py-2 px-3"
                                    type="button"
                                    @click="selectLocation(null)"
                                    :class="{'bg-primary bg-opacity-10': form.id_place_location === null}">
                              <i class="bi bi-building me-3 mt-1 text-primary" style="font-size: 1.1rem;"></i>
                              <div class="flex-grow-1">
                                <div class="fw-bold text-dark">{{ place?.place_name }}</div>
                                <div class="small mt-1">Local padrão de atendimento</div>
                              </div>
                              <i v-if="form.id_place_location === null" class="bi bi-check-circle-fill text-primary ms-2"></i>
                            </button>
                          </li>
                          <li><hr class="dropdown-divider my-2"></li>
                          <li v-for="location in locations" :key="location.id_place_location">
                            <button class="dropdown-item d-flex align-items-start py-2 px-3"
                                    type="button"
                                    @click="selectLocation(location.id_place_location)"
                                    :class="{'bg-primary bg-opacity-10': form.id_place_location === location.id_place_location}">
                              <i class="bi bi-geo-alt-fill me-3 mt-1 text-primary" style="font-size: 1.1rem;"></i>
                              <div class="flex-grow-1">
                                <div class="fw-bold text-dark">{{ location.location_nickname || location.location_name }}</div>
                                <div class="small mt-1" v-if="location.location_address">
                                  {{ location.location_address }}{{ location.location_addr_numer ? ', ' + location.location_addr_numer : '' }}
                                </div>
                              </div>
                              <i v-if="form.id_place_location === location.id_place_location" class="bi bi-check-circle-fill text-primary ms-2"></i>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <label class="form-check-label d-inline-flex align-items-center gap-2 mb-0" v-if="isScheduleDateMoreThanToday() && hasPermission('Fit Into Schedule') && acceptsFittedSchedule">
                      <input class="form-check-input m-0" type="checkbox" v-model="form.sched_is_fitted"
                             id="isScheduleFit" @change="form.sched_time = ''; form.id_place_location = '';">
                      Encaixar
                    </label>
                    </div>
                    <input type="text" class="form-control form-control-solid"
                           v-mask="'##:##'" required v-if="form.sched_is_fitted"
                           placeholder="HH:MM" v-model="form.sched_time"/>

                    <select name="" id="" required v-model="form.sched_time" v-else
                            :disabled="!isScheduleDateMoreThanToday()"
                            class="form-control form-control-solid" size="10"
                            @change="onTimeSelected">

                      <option :value="scheduleEdit.sched_time"
                              v-if="scheduleEdit != null && date(scheduleEdit.sched_date, 'YYYY-MM-DD').format('DD/MM/YYYY') == date(this.form.sched_date).format('DD/MM/YYYY')">
                        {{ scheduleEdit.sched_time }}
                      </option>
                      <option :key="time.available_time" :value="time.available_time"
                              v-for="time in timesAvailabilityToSchedule"
                              :data-location-id="time.id_place_location">
                        {{ time.available_time }}
                      </option>
                    </select>
                    <p v-if="!form.sched_is_fitted && !scheduleEdit && timesAvailabilityToSchedule.length === 0" class="schedule-editor__empty-times" role="status">
                      {{ form.sched_date ? 'Nenhum horário disponível. Selecione outra data ou use encaixe, se permitido.' : 'Selecione uma data para consultar os horários disponíveis.' }}
                    </p>


                  </div>
                  <div class="col-md-5" v-if="form.is_recurrence">
                    <div class="row">
                      <div class="col-md-12">
                        <label class="fs-6 fw-bold mb-2 required">Tipo de recorrência</label>
                        <select class="form-control form-control-solid" @change="onTpRecurrenceChange()"
                                v-model="form.recurrence.tp_recurrence">
                          <option :value="null">--Selecione--</option>
                          <option value="W">Semanal: toda {{ date(form.sched_date).format('dddd') }}</option>
                          <option value="M">Semanal: Segunda a sexta-feira</option>
                          <option value="A">Todos os dias</option>
                          <option value="P">Personalizada</option>
                        </select>
                        <br>
                      </div>
                      <div v-if="form.recurrence.tp_recurrence === 'P'" class="row mb-4">
                        <div class="col-md-4">
                          <p class="mt-3">Repetir a cada:</p>
                        </div>
                        <div class="col-md-3">
                          <input type="number" v-model="form.recurrence.interval" min="1"
                                 class="form-control form-control-solid">
                        </div>
                        <div class="col-md-5">
                          <select class="form-control form-control-solid"
                                  v-model="form.recurrence.frequency"
                                  @change="() => {
                                    if(this.form.recurrence.tp_end !== 'weekly') {
                                      this.form.recurrence.days_of_week = [this.date(this.form.sched_date).locale('en').format('dddd').toLowerCase()];
                                    }
                                  }">
                            <option value="daily">{{ form.recurrence.interval > 1 ? 'Dias' : 'Dia' }}</option>
                            <option value="weekly">{{ form.recurrence.interval > 1 ? 'Semanas' : 'Semana' }}</option>
                            <option value="monthly">{{ form.recurrence.interval > 1 ? 'Meses' : 'Mês' }}</option>
                          </select>
                        </div>
                        <div class="row" style="padding-left: 15px; padding-right: 0"
                             v-if="form.recurrence.frequency === 'weekly'">
                          <div class="mt-4 text-center" style="padding-left: 0; padding-right: 0">
                            <div style="padding-left: 0; padding-right: 0">
                              <input type="checkbox" class="btn-check" name="btnradio"
                                     v-model="form.recurrence.days_of_week" value="sunday"
                                     id="btnradio-dom" autocomplete="off">
                              <label class="btn btn-outline-primary border-primary" for="btnradio-dom"
                                     style="padding: calc(0.55rem + 1px) calc(0.55rem + 1px);">
                                Dom
                              </label>
                              <input type="checkbox" class="btn-check" name="btnradio"
                                     v-model="form.recurrence.days_of_week" value="monday"
                                     id="btnradio-seg" autocomplete="off">
                              <label class="btn btn-outline-primary border-primary ms-1"
                                     style="padding: calc(0.55rem + 1px) calc(0.75rem + 1px);"
                                     for="btnradio-seg">
                                Seg
                              </label>
                              <input type="checkbox" class="btn-check" name="btnradio"
                                     v-model="form.recurrence.days_of_week" value="tuesday"
                                     id="btnradio-ter" autocomplete="off">
                              <label class="btn btn-outline-primary border-primary ms-1"
                                     style="padding: calc(0.55rem + 1px) calc(0.75rem + 1px);"
                                     for="btnradio-ter">
                                Ter
                              </label>
                              <input type="checkbox" class="btn-check" name="btnradio"
                                     v-model="form.recurrence.days_of_week" value="wednesday"
                                     id="btnradio-qua" autocomplete="off">
                              <label class="btn btn-outline-primary ms-1"
                                     style="padding: calc(0.55rem + 1px) calc(0.75rem + 1px);"
                                     for="btnradio-qua">
                                Qua
                              </label>
                              <input type="checkbox" class="btn-check" name="btnradio"
                                     v-model="form.recurrence.days_of_week" value="thursday"
                                     id="btnradio-qui" autocomplete="off">
                              <label class="btn btn-outline-primary border-primary ms-1"
                                     style="padding: calc(0.55rem + 1px) calc(0.75rem + 1px);"
                                     for="btnradio-qui">
                                Qui
                              </label>
                              <input type="checkbox" class="btn-check" name="btnradio"
                                     v-model="form.recurrence.days_of_week" value="friday"
                                     id="btnradio-sex" autocomplete="off">
                              <label class="btn btn-outline-primary ms-1"
                                     style="padding: calc(0.55rem + 1px) calc(0.75rem + 1px);"
                                     for="btnradio-sex">
                                Sex
                              </label>
                              <input type="checkbox" class="btn-check" name="btnradio"
                                     v-model="form.recurrence.days_of_week" value="saturday"
                                     id="btnradio-sab" autocomplete="off">
                              <label class="btn btn-outline-primary border-primary ms-1"
                                     style="padding: calc(0.55rem + 1px) calc(0.75rem + 1px);"
                                     for="btnradio-sab">
                                Sab
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="form.recurrence.tp_recurrence" class="col-md-12">
                        <div class="fv-row">
                          <label class="fs-6 fw-bold required mb-2">Termina em</label>
                          <select class="form-control form-control-solid"
                                  @change="() => {
                                    if(this.form.recurrence.tp_end === 'number') {
                                      this.form.recurrence.max_occurrences = 1;
                                      this.form.recurrence.end_date = null;
                                    } else {
                                      this.form.recurrence.end_date = this.date().format('DD/MM/YYYY');
                                      this.form.recurrence.max_occurrences = null;
                                    }
                                  }"
                                  v-model="form.recurrence.tp_end">
                            <option value="number">Após x ocorrências</option>
                            <option value="date">Em uma data</option>
                          </select>
                        </div>

                        <div class="col-md-12" v-if="form.recurrence.tp_end === 'number'">
                          <div class="fv-row">
                            <label class="fs-6 required fw-bold mb-2">Qtd ocorrências</label>
                            <input type="number" v-model="form.recurrence.max_occurrences" min="1"
                                   class="form-control form-control-solid">
                          </div>
                        </div>
                        <div class="col-md-12" v-if="form.recurrence.tp_end === 'date'">
                          <div class="fv-row">
                            <label class="fs-6 required fw-bold mb-2">Data final</label>
                            <input type="tel" v-model="form.recurrence.end_date" min="1" v-mask="'##/##/####'"
                                   placeholder="DD/MM/YYYY"
                                   class="form-control form-control-solid">
                          </div>
                        </div>

                        <button class="btn btn-sm btn-secondary mt-4 text-center"
                                type="button"
                                @click="preScheduleRecurrence()">
                          Pré-visualizar datas
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                </aside>
                <div class="modal-footer schedule-editor__footer" v-if="isScheduleDateMoreThanToday()">
                  <button type="button" class="schedule-editor__button" data-bs-dismiss="modal" @click="$emit('onCloseModal')">Fechar</button>
                  <button type="submit" class="schedule-editor__button schedule-editor__button--primary" :disabled="submiting"
                          v-if="hasPermission(scheduleEdit ? 'Update Schedule' : 'Store Schedule')">
                    <span class="indicator-label">{{
                        submiting ? 'Salvando…' : (rescheduling ? 'Reagendar' : (scheduleEdit ? 'Atualizar agendamento' : 'Salvar agendamento'))
                      }}</span>
                    <span class="indicator-progress">Por favor aguarde...
                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  </button>
                </div>
              </form>

            </div>
            <div class="tab-pane fade" id="data-history-modal" role="tabpanel"
                 aria-labelledby="profile-tab" v-show="scheduleEdit != null">

              <PatientScheduleTable v-if="scheduleEdit != null && showHistory"
                                    :uniqueKey="this.uniqueKey + '|'+ this.scheduleEdit.id_patient"
                                    :patientId="this.scheduleEdit.id_patient"
                                    :showBtnEdit="false"/>
            </div>
            <div class="tab-pane fade" id="data-notifications-modal" role="tabpanel"
                 aria-labelledby="data-notifications-modal" v-show="scheduleEdit != null">

              <ScheduleMessageTable v-if="scheduleEdit != null && showHistory"
                                    :uniqueKey="this.uniqueKey + '|' + this.scheduleEdit.id_sched"
                                    :scheduleId="this.scheduleEdit.id_sched"
              />

            </div>
            <div class="tab-pane fade" id="data-files-modal" role="tabpanel"
                 aria-labelledby="data-files-modal" v-show="scheduleEdit != null">

              <ScheduleFilesTable v-if="scheduleEdit != null && showHistory"
                                  :uniqueKey="this.uniqueKey + '|' + this.scheduleEdit.id_sched"
                                  :scheduleId="this.scheduleEdit.id_sched"
              />

            </div>
            <div class="tab-pane fade" id="data-pre-schedule-modal" role="tabpanel"
                 aria-labelledby="data-pre-schedule-modal" v-show="scheduleEdit != null">

              <div class="pt-4" v-if="scheduleEdit != null && showHistory">
                <PreScheduleAnswerView
                  :schedule-id="scheduleEdit.id_sched"
                  :unique-key="uniqueKey + '|' + scheduleEdit.id_sched"
                  editable
                />
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </Teleport>

  <ModalNfseConfirmation
    ref="modalNfseConfirmation"
    @confirmed="onNfseConfirmed"
    @cancelled="onNfseCancelled"
  />

  <ModalTissGuideConfirmation
    ref="modalTissGuideConfirmation"
    @confirmed="onGuideConfirmed"
    @cancelled="onGuideCancelled"
  />

  <PixPaymentModal
    ref="pixPaymentModal"
    :pixData="pixModalData"
    @onClose="pixModalData = null"
    @paymentConfirmed="loadScheduleGuide"
  />

  <ModalPatient
    v-if="currentPatientData"
    :patient="currentPatientData"
    :open-modal="isEditPatientModalOpen"
    :key="'modal-patient-' + currentPatientData?.id_patient"
    @onCloseModal="onCloseModalEditPatient"
    @onPatientUpdated="onPatientUpdated"
  />

  <div
    class="modal fade"
    id="modal_schedule_participant"
    tabindex="-1"
    aria-hidden="true"
    ref="participantModal"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Adicionar participante</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
        </div>
        <div class="modal-body">
          <p class="text-muted small">
            O paciente do agendamento já participa automaticamente da chamada.
            Informe aqui o e-mail de pessoas extras que devem receber um convite com link exclusivo.
          </p>
          <label class="form-label required" for="participant_email">E-mail do participante</label>
          <input
            id="participant_email"
            type="email"
            class="form-control form-control-solid"
            v-model="participantEmailInput"
            placeholder="exemplo@email.com"
            @keyup.enter="addParticipant"
          >
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-primary" @click="addParticipant">Adicionar</button>
        </div>
      </div>
    </div>
  </div>

  <ModalScheduleRecurrenceSessions
    :open="openRecurrenceSessions"
    :sched-recur-id="scheduleEdit?.sched_recur_id"
    :current-sched-id="scheduleEdit?.id_sched"
    @close="openRecurrenceSessions = false"
    @view-schedule="onViewRecurrenceSchedule"
  />
</template>

<style scoped>
.schedule-editor__check { display: flex; align-items: center; gap: 8px; padding-left: 0; min-height: 24px; }
.schedule-editor__check .form-check-input { float: none; margin: 0; width: 22px; height: 22px; flex-shrink: 0; }
.schedule-editor__check .form-check-label { margin: 0; font-size: 13px; font-weight: 400; line-height: 1.5; color: #302b38; cursor: pointer; }

.online-participants-card {
  border: 1px solid #e7e2eb !important;
  border-radius: 12px;
  box-shadow: none;
}
.online-participants-card > .card-body { padding: 18px 20px; }
.online-participants__header { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px 16px; margin-bottom: 12px; }
.online-participants__intro { flex: 1 1 260px; }
.online-participants__title { margin: 0 0 5px; color: #302b38; font-size: 14px; font-weight: 600; }
.online-participants__add { display: inline-flex; align-items: center; justify-content: center; gap: 8px; flex-shrink: 0; white-space: nowrap; min-height: 36px; border-radius: 8px; }
.online-participants__add i { padding: 0; font-size: 16px; }

</style>

<script>
import { patientIdentity, identityError } from '../../helpers/patientIdentity';
import Permission from "../../helpers/permission";
import {mask} from "vue-the-mask";
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import SelectUbbi from "../../components/SelectUbbi.vue";
import Calendar from "primevue/calendar";
import SearchPatient from "../../components/SearchPatient";
import PatientScheduleTable from "../patient/PatientScheduleTable";
import BusyRateLegend from "./BusyRateLegend";
import BtnFinishOrReOpenSchedule from "./BtnFinishOrReOpenSchedule";
import BtnStartAttendanceSchedule from "./BtnStartAttendanceSchedule";
import BtnArriveSchedule from "./BtnArriveSchedule";
import BtnCancelSchedule from "./BtnCancelSchedule";
import BtnAddWaitingListSchedule from "./BtnAddWaitingListSchedule";
import ScheduleMessageTable from "./ScheduleMessageTable";
import ScheduleFilesTable from "./ScheduleFilesTable";
import PreScheduleAnswerView from "../pre_schedule/PreScheduleAnswerView.vue";
import date from "../../helpers/date";
import moment from "moment";
import ModalNfseConfirmation from "./ModalNfseConfirmation.vue";
import ModalTissGuideConfirmation from "./ModalTissGuideConfirmation.vue";
import ModalPatient from "../patient/ModalPatient.vue";
import PixPaymentModal from "../../components/PixPaymentModal.vue";
import Modal from "../../helpers/modal";
import Loader from "../../helpers/loader";
import Download from "../../helpers/download";
import ScheduleRecurrenceBadge from "./ScheduleRecurrenceBadge.vue";
import ModalScheduleRecurrenceSessions from "./ModalScheduleRecurrenceSessions.vue";
import ModalScheduleProgram from "./ModalScheduleProgram.vue";

export default {
  name: "CalendarModalScheduleEdit",
  props: ['scheduleEdit', 'openModal', 'showHistory', 'clickedDate', 'currentProf', 'currentSpec', 'waitingList'],
  emits: ['onCloseModal', 'onArriveSchedule', 'onScheduleUpdate', 'onScheduleStore', 'onScheduleCancel', 'onConfirmSchedule', 'onReopenSchedule', 'onFinishSchedule', 'onStartAttendance', 'onSwitchSchedule'],
  components: {
    BusyRateLegend,
    SearchPatient,
    SelectUbbi,
    Calendar,
    PatientScheduleTable,
    BtnFinishOrReOpenSchedule,
    BtnStartAttendanceSchedule,
    BtnArriveSchedule,
    BtnCancelSchedule,
    ScheduleMessageTable,
    BtnAddWaitingListSchedule,
    ScheduleFilesTable,
    PreScheduleAnswerView,
    ModalNfseConfirmation,
    ModalTissGuideConfirmation,
    ModalPatient,
    PixPaymentModal,
    ScheduleRecurrenceBadge,
    ModalScheduleRecurrenceSessions,
    ModalScheduleProgram,
  },
  directives: {
    mask
  },
  data() {
    return {
      specialties: [],
      paymentMethods: [],
      insurances: [],
      locations: [],
      datesAvailabilityToSchedule: [],
      timesAvailabilityToSchedule: [],
      uniqueKey: Date.now(),
      patient_last_schedule: '',
      form: {
        sched_date: '',
        sched_time: '',
        sched_by: 'PL',
        sched_type: 'NV',
        sched_patient_name: '',
        sched_patient_cpf: '',
        sched_patient_phone: '',
        sched_patient_birthdate: '',
        id_patient: null,
        sched_obs: '',
        id_avail: '',
        id_insurance: '',
        id_paymeth: '',
        id_prof: '',
        id_spec: '',
        id_sched: null,
        id_place: '',
        id_place_location: null,
        sched_guide_number: '',
        sched_value: '',
        sched_is_fitted: false,
        add_waiting_list: false,
        wl_wait_at: '',
        wl_obs: '',
        id_wl: null,
        avail_online: false,
        participants: [],
        recurrence: {
          tp_recurrence: null,
          frequency: 'daily',
          tp_end: 'number',
          days_of_week: [],
          end_date: null,
          interval: 1,
          max_occurrences: 1,
        },
      },
      is_recurrence_pre: false,
      is_recurrence: false,
      submiting: false,
      curentWaitingList: null,
      rescheduling: false,
      generatingNfse: false,
      scheduleNfse: null,
      loadingNfseActions: false,
      emailToSend: '',
      generatingGuide: false,
      scheduleGuide: null,
      loadingGuideActions: false,
      pixModalData: null,
      currentPatientData: null,
      isEditPatientModalOpen: false,
      participantEmailInput: '',
      openRecurrenceSessions: false,
      isProgramMode: false,
      showProgramView: false,
    }
  },
  computed: {
    currentPatientId() {
      return this.scheduleEdit?.id_patient ?? this.form.id_patient ?? null;
    },
    place() {
      return this.$store.state.auth.place;
    },
    professionals() {
      return this.$store.state.auth.professionals;
    },
    userAuth() {
      return this.$store.state.auth.user;
    },
    selectedProfessional() {
      if (!this.form.id_prof || !this.professionals) {
        return null;
      }
      return this.professionals.find(p => p.id_prof === this.form.id_prof);
    },
    acceptsFittedSchedule() {
      if (!this.selectedProfessional) {
        return true;
      }
      return this.selectedProfessional.accepts_fitted_schedule !== undefined 
        ? this.selectedProfessional.accepts_fitted_schedule 
        : true;
    },
    professionalAttendsOnline() {
      const releaseFor = this.selectedProfessional?.default_release_time_for;
      return releaseFor === 'B' || releaseFor === 'O';
    },
    canDownloadDanfse() {
      if (!this.scheduleNfse) return false;
      return this.scheduleNfse.nfse_status === 'authorized';
    },
    scheduleTypeOptions() {
      return [
        { code: 'NV', name: 'Nova Agenda' },
        { code: 'RT', name: 'Retorno' },
      ];
    },
  },
  mounted() {
    this.loadLocations();
    if (this.scheduleEdit) {
      this.openExistingSchedule();
    } else if (this.openModal) {
      this.openNewSchedule();
    }
  },
  watch: {
    place() {
      this.loadLocations();
    },
    'scheduleEdit.has_nfse': {
      handler() {
        if (this.scheduleEdit?.has_nfse) {
          this.loadScheduleNfse();
        } else {
          this.scheduleNfse = null;
        }
      },
      immediate: true,
    },
    'scheduleEdit.has_tiss_guide': {
      handler() {
        if (this.scheduleEdit?.has_tiss_guide) {
          this.loadScheduleGuide();
        } else {
          this.scheduleGuide = null;
        }
      },
      immediate: true,
    },
    waitingList(newValue, _) {
      this.curentWaitingList = newValue;

      if (newValue !== null) {
        this.resetForm();

        this.onChangeProf(this.curentWaitingList.id_prof).then(() => {

          this.form = {
            sched_by: 'PL',
            sched_type: 'NV',
            id_wl: this.curentWaitingList.id_wl,
            id_spec: this.curentWaitingList.id_spec,
            id_prof: this.curentWaitingList.id_prof,
            id_paymeth: this.curentWaitingList.id_paymeth,
            id_insurance: this.curentWaitingList.id_insurance,
            sched_patient_name: this.curentWaitingList.wl_name,
            ...patientIdentity(this.curentWaitingList.patient || {}),
            sched_patient_cpf: this.curentWaitingList.wl_cpf,
            sched_patient_phone: this.curentWaitingList.wl_phone,
            sched_patient_birthdate: this.curentWaitingList.wl_dt_birth ? this.date(this.curentWaitingList.wl_dt_birth).format('DD/MM/YYYY') : this.curentWaitingList.patient?.patient_birthdate_br,
            is_recurrence: false,
            recurrence: {
              tp_recurrence: null,
              frequency: 'daily',
              tp_end: 'number',
              days_of_week: [],
              end_date: null,
              interval: 1,
              max_occurrences: 1,
            },
          };

          this.loadDatesAvailabilityToSchedule(this.form.sched_date);
        });

        this.showModal();
      }
    },
    scheduleEdit(newValue, _) {
      if (newValue == null) {
        this.resetForm();
        this.scheduleGuide = null;
        return;
      }

      this.openExistingSchedule();
    },
    openModal(newValue) {
      if (newValue) {
        if (this.scheduleEdit) {
          return;
        }
        this.openNewSchedule();
        return;
      }

      this.resetForm();
    },
    clickedDate(newValue) {
      if (newValue) {
        let date = this.date(newValue);

        this.form.sched_date = newValue;
        this.form.sched_time = date.format('HH:mm');
      }
    }
  },
  methods: {
    date: date,
    openExistingSchedule() {
      this.isProgramMode = false;
      this.showProgramView = false;
      this.scheduleGuide = null;

      this.populateForm()
        .then(() => {
          this.loadDatesAvailabilityToSchedule(this.form.sched_date)
            .then(() => {
              this.loadTimesAvailabilityToSchedule(this.form.sched_date);
            });
        });
    },
    openNewSchedule() {
      document.getElementById('data-schedule-modal-tab')?.click();
      this.form.id_prof = this.currentProf ?? this.userAuth.id_prof ?? '';
      this.form.id_spec = this.currentSpec ?? '';
      this.onChangeProf(this.form.id_prof);
      this.showModal();
    },
    hasPermission(permission) {
      return Permission.has(permission);
    },
    onSelectDate(selectedDate) {
      this.form.sched_date = selectedDate;
      this.form.sched_time = '';

      this.loadTimesAvailabilityToSchedule(selectedDate);
    },
    onChangeMonth(newDate) {
      const formattedDate = `${newDate.year}-${(newDate.month).toString().padStart(2, '0')}-01`;
      this.loadDatesAvailabilityToSchedule(formattedDate);
    },
    preScheduleRecurrence() {
      this.form.is_recurrence_pre = true;
      this.onSubmit();
    },
    onTpRecurrenceChange() {
      let tpRecurrence = this.form.recurrence.tp_recurrence;
      if (tpRecurrence === 'A') {
        this.form.recurrence.days_of_week = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
        this.form.recurrence.frequency = 'daily';
        this.form.recurrence.interval = 1;
      } else if (tpRecurrence === 'W') {
        this.form.recurrence.days_of_week = [this.date(this.form.sched_date).locale('en').format('dddd').toLowerCase()];
        this.form.recurrence.frequency = 'weekly';
        this.form.recurrence.interval = 1;
      } else if (tpRecurrence === 'M') {
        this.form.recurrence.days_of_week = ["monday", "tuesday", "wednesday", "thursday", "friday"];
        this.form.recurrence.frequency = 'weekly';
        this.form.recurrence.interval = 1;
      } else if (tpRecurrence === 'P') {
        this.form.recurrence.days_of_week = [];
        this.form.recurrence.frequency = 'weekly';
        this.form.recurrence.interval = 1;
      }
    },
    insuranceLabel(option) {
      if (!option) return '';
      return option.trading_name
        ? `${option.trading_name} - ${option.insurance_name}`
        : option.insurance_name;
    },
    onChangeProf(idProf) {
      if (!idProf)
        return;

      const professional = this.professionals.find(p => p.id_prof === idProf);
      if (professional && professional.accepts_fitted_schedule === false) {
        this.form.sched_is_fitted = false;
      }

      if (professional && !['B', 'O'].includes(professional.default_release_time_for)) {
        this.form.avail_online = false;
        this.form.participants = [];
      }

      let resSpecs = this.loadSpecialties(idProf);
      let resPayment = this.loadPaymentMethods(idProf);
      let resInsurance = this.loadInsurances(idProf);

      return Promise.all([resPayment, resInsurance, resSpecs]);
    },
    loadDatesAvailabilityToSchedule(startDate) {
      if (!this.place.id_place || !this.form.id_prof ||
        !this.form.id_spec || !this.place.id_city ||
        !this.form.id_paymeth) {
        return new Promise(resolve => {
        });
      }

      return http.get('/schedule/availabilities', {
        params: {
          id_place: this.place.id_place,
          id_prof: this.form.id_prof,
          id_spec: this.form.id_spec,
          id_city: this.place.id_city,
          id_paymeth: this.form.id_paymeth,
          id_insurance: this.form.id_insurance,
          start_date: startDate,
          start_end_days: 32,
          //with_all_dates: 'S',
        }
      }).then((response) => {
        this.datesAvailabilityToSchedule = response.data;
        if (this.clickedDate) {
          let date = this.date(this.clickedDate);
          this.loadTimesAvailabilityToSchedule(date.format('YYYY/MM/DD'));
        }
      });
    },
    loadTimesAvailabilityToSchedule(date) {
      if (!this.place.id_place || !this.form.id_prof ||
        !this.form.id_spec || !this.place.id_city ||
        !this.form.id_paymeth) {
        return;
      }

      http.get('/schedule/availabilities/times', {
        params: {
          id_place: this.place.id_place,
          id_prof: this.form.id_prof,
          id_spec: this.form.id_spec,
          id_city: this.place.id_city,
          id_paymeth: this.form.id_paymeth,
          id_insurance: this.form.id_insurance,
          available_date: date,
        }
      }).then((response) => {
        this.timesAvailabilityToSchedule = response.data;
        
        if (this.form.sched_time) {
          const selectedTimeOption = this.timesAvailabilityToSchedule.find(time => time.available_time === this.form.sched_time);
          if (selectedTimeOption) {
            this.form.id_place_location = selectedTimeOption.id_place_location || null;
          }
        }

        if (!this.acceptsFittedSchedule) {
          this.form.sched_is_fitted = false;
          return;
        }
        
        if (this.clickedDate) {
          let date = this.date(this.clickedDate);
          const existTime = this.timesAvailabilityToSchedule.some(obj => obj.available_time == date.format('HH:mm'));

          if (this.hasPermission('Fit Into Schedule')) {
            this.form.sched_is_fitted = !existTime && this.acceptsFittedSchedule;
          }
        } else {
          if (this.scheduleEdit && this.date(this.scheduleEdit.sched_date, 'YYYY-MM-DD').format('YYYY-MM-DD') == this.date(date).format('YYYY-MM-DD')) {
            this.form.sched_is_fitted = this.scheduleEdit.sched_is_fitted && this.acceptsFittedSchedule;
          } else {
            this.form.sched_is_fitted = this.timesAvailabilityToSchedule.length <= 0 && this.acceptsFittedSchedule;
          }
        }
      });
    },
    dateIsAvailabilityToSchedule(date) {
      const searchDate = this.date(date).format('YYYY-MM-DD');
      return this.datesAvailabilityToSchedule.some(event => event.available_date === searchDate);
    },
    getTextColor(date) {
      const searchDate = this.date(date).format('YYYY-MM-DD');
      const event = this.datesAvailabilityToSchedule.find(event => event.available_date === searchDate);
      return event?.text_color;
    },
    getEventRate(date) {
      const searchDate = this.date(date).format('YYYY-MM-DD');
      const event = this.datesAvailabilityToSchedule.find(event => event.available_date === searchDate);
      return event?.busy_rate;
    },
    getBackgoundColor(date) {
      const searchDate = this.date(date).format('YYYY-MM-DD');
      const event = this.datesAvailabilityToSchedule.find(event => event.available_date === searchDate);

      return event?.background_color;
    },
    isScheduleDateMoreThanToday() {
      let dataMoment = moment.utc(this.scheduleEdit?.sched_date).startOf('day');
      let dataAtual = moment.utc().startOf('day');
      return dataAtual.isSameOrBefore(dataMoment, 'day');
    },
    arriveSchedule() {
      this.$emit('onCloseModal');
      this.$emit('onArriveSchedule', this.scheduleEdit.id_sched);
      this.toggleModal();
    },
    onViewRecurrenceSchedule(schedule) {
      this.openRecurrenceSessions = false;
      this.$emit('onSwitchSchedule', schedule);
    },
    onProgramSaved() {
      this.isProgramMode = false;
      this.$emit('onScheduleStore');
      this.$emit('onCloseModal');
      this.toggleModal();
    },
    populateForm() {
      if (!this.scheduleEdit)
        return new Promise(resolve => {});

      let resSpecs = this.loadSpecialties(this.scheduleEdit.id_prof);
      let resPayment = this.loadPaymentMethods(this.scheduleEdit.id_prof);
      let resInsurance = this.loadInsurances(this.scheduleEdit.id_prof);

      return Promise.all([resPayment, resInsurance, resSpecs]).then(() => {
        let schedDate = new Date(moment.utc(this.scheduleEdit.sched_date).startOf('day').format('YYYY-MM-DDTHH:mm:ss'));
        this.form = {
          id_spec: this.scheduleEdit.id_spec,
          id_prof: this.scheduleEdit.id_prof,
          id_paymeth: this.scheduleEdit.id_paymeth,
          id_avail: this.scheduleEdit.id_avail,
          id_place_location: this.scheduleEdit.id_place_location,
          sched_time: this.scheduleEdit.sched_time,
          sched_patient_name: this.scheduleEdit.patient_name,
          ...patientIdentity(this.scheduleEdit),
          sched_patient_cpf: this.scheduleEdit.patient_cpf,
          sched_patient_phone: this.scheduleEdit.patient_phone,
          sched_patient_birthdate: this.scheduleEdit.patient_birthdate_br,
          sched_guide_number: this.scheduleEdit.sched_guide_number,
          sched_obs: this.scheduleEdit.sched_obs,
          id_insurance: this.scheduleEdit.id_insurance,
          id_sched: this.scheduleEdit.id_sched,
          sched_is_fitted: this.scheduleEdit.sched_is_fitted,
          sched_date: schedDate,
          sched_type: this.scheduleEdit.sched_type,
          sched_value: this.scheduleEdit.sched_value,
          avail_online: !!this.scheduleEdit.sched_online,
          participants: [],
          is_recurrence: false,
          recurrence: {
            tp_recurrence: null,
            frequency: 'daily',
            tp_end: 'number',
            days_of_week: [],
            end_date: null,
            interval: 1,
            max_occurrences: 1,
          },
        };

        let paymentMethod = this.paymentMethods.find(p => p.id_paymeth === this.scheduleEdit.id_paymeth);
        if (!paymentMethod) {
          this.paymentMethods.push({
            id_paymeth: this.scheduleEdit.id_paymeth,
            paymeth_name: this.scheduleEdit.paymeth_name
          });
        }

        let insurance = this.insurances.find(i => i.id_insurance === this.scheduleEdit.id_insurance);
        if (!insurance) {
          this.insurances.push({
            id_insurance: this.scheduleEdit.id_insurance,
            insurance_name: this.scheduleEdit.insurance_name
          });
        }

        if (this.form.avail_online) {
          this.loadScheduleParticipants(this.scheduleEdit.id_sched);
        }

        this.showModal();
      });
    },
    onToggleAvailOnline() {
      if (this.form.avail_online) {
        this.form.id_place_location = null;
        return;
      }

      this.form.participants = [];
    },
    openParticipantModal() {
      this.participantEmailInput = '';
      const el = this.$refs.participantModal;
      if (el) {
        bootstrap.Modal.getOrCreateInstance(el).show();
      }
    },
    closeParticipantModal() {
      const el = this.$refs.participantModal;
      bootstrap.Modal.getInstance(el)?.hide();
    },
    addParticipant() {
      const email = (this.participantEmailInput || '').trim().toLowerCase();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!email || !emailRegex.test(email)) {
        Alert.toastError('Informe um e-mail válido.');
        return;
      }

      if (!this.form.participants) {
        this.form.participants = [];
      }

      if (this.form.participants.some((participant) => participant.email === email)) {
        Alert.toastError('Este e-mail já foi adicionado.');
        return;
      }

      this.form.participants.push({
        email,
        attendance_link: null,
      });
      this.closeParticipantModal();
    },
    removeParticipant(index) {
      this.form.participants.splice(index, 1);
    },
    copyParticipantLink(participant) {
      if (!participant.attendance_link) {
        Alert.toastInfo('Salve o agendamento para gerar o link deste participante.');
        return;
      }

      navigator.clipboard.writeText(participant.attendance_link).then(() => {
        Alert.toastSuccess('Link copiado para a área de transferência.');
      }).catch(() => {
        Alert.toastError('Erro ao copiar o link.');
      });
    },
    buildParticipantsPayload() {
      if (!this.form.avail_online) {
        return [];
      }

      return (this.form.participants || []).map((participant) => ({
        email: participant.email,
      }));
    },
    mapParticipantsFromApi(participants) {
      return (participants || []).map((participant) => ({
        email: participant.sp_email,
        attendance_link: participant.attendance_link,
        id_schedule_participant: participant.id_schedule_participant,
      }));
    },
    loadScheduleParticipants(scheduleId) {
      if (!scheduleId || !this.place?.id_place) {
        return Promise.resolve();
      }

      return http.get(`/places/${this.place.id_place}/schedules/${scheduleId}`).then((response) => {
        this.form.participants = this.mapParticipantsFromApi(response.data.participants);
      });
    },
    allowInsurance() {
      if (!this.form.id_paymeth)
        return false;

      let paymentMethod = this.paymentMethods.find(p => p.id_paymeth === this.form.id_paymeth);
      return paymentMethod?.is_insurance;
    },
    isInPerson() {
      if (!this.form.id_paymeth)
        return false;

      let paymentMethod = this.paymentMethods.find(p => p.id_paymeth === this.form.id_paymeth);
      return paymentMethod?.is_in_person;
    },
    onStartAttendance() {
      this.$emit('onStartAttendance');
      this.$emit('onCloseModal');
      this.toggleModal();
    },
    onReopenSchedule() {
      this.$emit('onReopenSchedule');
      this.$emit('onCloseModal');
      this.toggleModal();
    },
    onFinishSchedule() {
      this.$emit('onFinishSchedule');
      this.$emit('onCloseModal');
      this.toggleModal();
    },
    confirmSchedule(schedStatus) {
      let action = schedStatus === 'CO' ? 'not-confirm' : `confirm`;
      let scheduleId = this.form.id_sched ?? this.scheduleEdit.id_sched;
      http.patch(`/places/${this.place.id_place}/schedules/${scheduleId}/${action}`).then(() => {
        Alert.toastSuccess("Agendamento confirmado com sucesso.");
        this.$emit('onConfirmSchedule');

        this.$emit('onCloseModal');
        this.toggleModal();
      }).catch((e) => {
        Alert.toastError(e.response.data);
      });
    },
    onSubmit() {
      if (!this.form.id_spec) {
        return Alert.toastError('Informe a especialidade.')
      }

      if (!this.form.sched_date) {
        return Alert.toastError('Informe a data.')
      }

      if (!this.form.sched_time) {
        return Alert.toastError('Informe a hora.')
      }

      if (!this.form.id_paymeth) {
        return Alert.toastError('Informe a forma de pagamento.')
      }

      if (!this.form.id_insurance && this.allowInsurance()) {
        return Alert.toastError('Informe o convênio médico.')
      }

      if (this.rescheduling) {
        this.reSchedule();
        return;
      }

      this.submiting = true;
      if (this.scheduleEdit) {
        this.updateSchedule();
        return;
      }

      if (this.form.is_recurrence) {
        this.storeRecurrence();
        return;
      }

      this.confirmFittedLocationAndProceed(() => this.storeSchedule());
    },
    confirmFittedLocationAndProceed(proceedCallback) {
      const isFittedWithLocations = this.form.sched_is_fitted
        && this.locations
        && this.locations.length > 0;

      if (!isFittedWithLocations) {
        proceedCallback();
        return;
      }

      const currentValue = this.form.id_place_location === null || this.form.id_place_location === undefined
        ? ''
        : String(this.form.id_place_location);
      const placeName = (this.place?.place_name || 'Local padrão').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      let optionsHtml = `<option value="">${placeName} (local padrão)</option>`;
      this.locations.forEach((loc) => {
        const name = (loc.location_nickname || loc.location_name || '').replace(/</g, '&lt;').replace(/"/g, '&quot;');
        const val = String(loc.id_place_location);
        const selected = currentValue === val ? ' selected' : '';
        optionsHtml += `<option value="${val}"${selected}>${name}</option>`;
      });

      Swal.fire({
        title: 'Confirmar local do encaixe',
        html: `
          <p class="text-start mb-3">Selecione a unidade/local onde será realizado o agendamento em encaixe:</p>
          <label for="swal-fitted-location" class="form-label text-start w-100">Unidade / local</label>
          <select id="swal-fitted-location" class="form-select form-select-solid">
            ${optionsHtml}
          </select>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Confirmar e agendar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#780f5a',
        width: '420px',
        preConfirm: () => {
          const select = document.getElementById('swal-fitted-location');
          const value = select ? select.value : '';
          return value;
        }
      }).then((result) => {
        if (result.isConfirmed && result.value !== undefined) {
          this.form.id_place_location = result.value === '' ? null : parseInt(result.value, 10);
          proceedCallback();
        } else {
          this.submiting = false;
        }
      });
    },
    updateSchedule() {
      this.form.id_place = this.place.id_place;
      const payload = {
        ...this.form,
        participants: this.buildParticipantsPayload(),
      };
      http.put(`/places/${this.place.id_place}/schedules/${this.form.id_sched}`, payload).then((response) => {
        Alert.toastSuccess("Agendamento atualizada com sucesso.");

        if (response.data?.participants) {
          this.form.participants = this.mapParticipantsFromApi(response.data.participants);
        }

        this.resetForm();
        this.$emit('onCloseModal');
        this.$emit('onScheduleUpdate');

        this.toggleModal();
      }).catch((e) => {
        Alert.toastError(identityError(e));
      }).finally(() => {
        this.submiting = false;
      });
    },
    storeSchedule() {
      const callStoreSchedule = () => {
        this.form.id_place = this.place.id_place;
        const payload = {
          ...this.form,
          participants: this.buildParticipantsPayload(),
        };
        http.post(`/places/${this.place.id_place}/schedules`, payload).then(() => {
          Alert.toastSuccess("Agendamento realizado com sucesso.");

          this.$emit('onCloseModal');
          this.$emit('onScheduleStore');
          this.toggleModal();
        }).catch((e) => {
          Alert.toastError(identityError(e));
        }).finally(() => {
          this.submiting = false;
        });
      }

      const checkReturningDeadline = () => {
        let url = `/places/${this.place.id_place}/schedules/check-returning-deadline`;
        http.get(url, {
          params: {
            ...patientIdentity(this.form),
            patient_cpf: this.form.sched_patient_cpf,
            id_spec: this.form.id_spec,
            id_prof: this.form.id_prof,
          }
        }).then((response) => {
          if (response.data?.length > 0) {
            let tableInfo = '<div style="max-height: min(300px, 40vh); overflow-y: auto;"><table class="table table-bordered">';
            tableInfo += '<thead><tr><th>Data e hora</th><th>Profissional</th><th>Especialidade</th></tr></thead><tbody>';

            response.data.forEach(item => {
              tableInfo += `<tr><td>${this.date(item.schedule_date_time).format("DD/MM/YYYY HH:mm")}</td><td>${item.prof_name}</td><td>${item.spec_name}</td></tr>`;
            });

            tableInfo += '</tbody></table></div>';

            let htmlInformations = `O documento <b>${this.form.document_number || this.form.sched_patient_cpf} (${this.form.sched_patient_name})</b>`
              .concat('<br>')
              .concat(`Está no período de RETORNO.`)
              .concat('<br>O que você gostaria de fazer a seguir?')
              .concat(tableInfo);

            Swal.fire({
              html: htmlInformations,
              icon: "warning",
              allowEscapeKey: false,
              allowOutsideClick: false,
              showCancelButton: true,
              showDenyButton: true,
              confirmButtonColor: "#780f5a",
              confirmButtonText: "Agendar retorno",
              cancelButtonText: "Continuar e fazer um novo agendamento",
              denyButtonText: "Não agendar e fechar",
              width: '800px',
            }).then((result) => {
              if (result.isConfirmed) {
                this.form.sched_type = 'RT';
              } else if (result.isDenied) {
                this.submiting = false;
                this.$emit('onCloseModal')
                this.toggleModal();
                return;
              }

              checkDuplicateSchedule();
            });
          } else {
            checkDuplicateSchedule();
          }
        });
      }

      const checkDuplicateSchedule = () => {
        let urlCheckDuplicateSchedules = `/places/${this.place.id_place}/schedules/check-duplicate`;
        http.get(urlCheckDuplicateSchedules, {
          params: {
            ...patientIdentity(this.form),
            patient_cpf: this.form.sched_patient_cpf,
            id_spec: this.form.id_spec,
            id_prof: this.form.id_prof,
          }
        }).then((response) => {
          if (response.data?.length > 0) {
            let tableInfo = '<div style="max-height: min(300px, 40vh); overflow-y: auto;"><table class="table table-bordered">';
            tableInfo += '<thead><tr><th>Data e hora</th><th>Profissional</th><th>Especialidade</th></tr></thead><tbody>';

            response.data.forEach(item => {
              tableInfo += `<tr><td>${this.date(item.schedule_date_time).format("DD/MM/YYYY HH:mm")}</td><td>${item.prof_name}</td><td>${item.spec_name}</td></tr>`;
            });

            tableInfo += '</tbody></table></div>';

            let htmlInformations = `O documento <b>${this.form.document_number || this.form.sched_patient_cpf} (${this.form.sched_patient_name})</b>`
              .concat('<br>')
              .concat(`Já possui um agendamento para esse profissional ou especialidade.`)
              .concat('<br>Tem certeza que deseja agendar?')
              .concat(tableInfo);

            Swal.fire({
              html: htmlInformations,
              icon: "warning",
              allowEscapeKey: false,
              allowOutsideClick: false,
              showCancelButton: true,
              showDenyButton: true,
              confirmButtonColor: "#780f5a",
              confirmButtonText: "Sim, agendar",
              cancelButtonText: "Não agendar e revisar",
              denyButtonText: "Não agendar e fechar",
              width: '800px',
            }).then((result) => {
              if (result.isConfirmed) {
                callStoreSchedule()
              } else if (result.isDismissed) {
                this.submiting = false;
              } else if (result.isDenied) {
                this.submiting = false;
                this.$emit('onCloseModal')
                this.toggleModal();
              }
            });
          } else {
            callStoreSchedule()
          }
        });
      }

      if (this.form.sched_type === 'NV') {
        checkReturningDeadline();
      } else {
        checkDuplicateSchedule()
      }
    },
    storeRecurrence() {
      const callStoreRecurrence = (pre) => {
        if (this.form.recurrence.tp_recurrence === null) {
          Alert.error('Informe o tipo de recorrência.');
          this.submiting = false;
          return;
        }

        this.form.id_place = this.place.id_place;
        http.post(`/places/${this.place.id_place}/schedules/recurrences` + (pre ? '/pre' : ''), this.form).then((response) => {
          if (pre) {
            let tableInfo = '<div style="max-height: 300px; overflow-y: auto;"><table class="table table-bordered">';
            tableInfo += '<thead><tr><th>Data</th><th>Hora</th><th>Dia</th></tr></thead><tbody>';

            response.data.forEach(item => {
              tableInfo += `<tr><td>${this.date(item).format("DD/MM/YYYY")}</td><td>${this.form.sched_time}</td><td>${this.date(item).format("dddd")}</td></tr>`;
            });

            tableInfo += '</tbody></table></div>';

            let htmlInformations = ``
              .concat(`Confira abaixo os dias e horários.`)
              .concat(tableInfo);

            Swal.fire({
              html: htmlInformations,
              icon: "warning",
              allowEscapeKey: false,
              allowOutsideClick: false,
              showCancelButton: true,
              confirmButtonColor: "#780f5a",
              confirmButtonText: "Agendar todos",
              cancelButtonText: "Não, revisar",
              width: '800px',
            }).then((result) => {
              if (result.isConfirmed) {
                callStoreRecurrence(false)
              } else {
                this.submiting = false;
              }
            });
          } else {
            Alert.toastSuccess("Agendamento realizado com sucesso.");

            this.$emit('onCloseModal');
            this.$emit('onScheduleStore');
            this.toggleModal();
          }

          this.form.is_recurrence_pre = false;
        }).catch((e) => {
          Alert.toastError(identityError(e));
        }).finally(() => {
          this.submiting = false;
        });
      }

      console.log(this.form);
      callStoreRecurrence(this.form.is_recurrence_pre);
    },
    reSchedule() {
      this.form.id_place = this.place.id_place;
      http.post(`/places/${this.place.id_place}/schedules/${this.form.id_sched}/reschedule`, this.form).then(() => {
        Alert.toastSuccess("Reagendamento realizado com sucesso.");

        this.resetForm();
        this.$emit('onCloseModal');
        this.$emit('onScheduleUpdate');

        this.toggleModal();
      }).catch((e) => {
        Alert.toastError(identityError(e));
      }).finally(() => {
        this.submiting = false;
      });
    },
    loadInsurances(idProf) {
      return http.get(`/places/${this.place.id_place}/professionals/${idProf}/insurances`).then((response) => {
        this.insurances = response.data.filter(insurance => insurance.enabled_to_prof_place === 1);
        return response;
      });
    },
    loadPaymentMethods(idProf) {
      let params = {from_calendar: true}
      return http.get(`/places/${this.place.id_place}/professionals/${idProf}/payment-methods`, {params: params}).then((response) => {
        this.paymentMethods = response.data.filter(payMethod => payMethod.enabled_to_prof_place === 1 && ['BO', 'PL'].includes(payMethod.allowed_for));
        if (this.paymentMethods.length === 1) {
          this.form.id_paymeth = this.paymentMethods[0].id_paymeth;
          this.loadDatesAvailabilityToSchedule(this.form.sched_date)
        }

        return response;
      });
    },
    loadSpecialties(idProf) {
      return http.get(`/places/${this.place.id_place}/professionals/${idProf}/specialties`).then((response) => {
        this.specialties = response.data;
        if (this.specialties.length === 1) {
          this.form.id_spec = this.specialties[0].id_spec;
        }

        return response;
      });
    },
    loadLocations() {
      if (!this.place?.id_place) {
        return;
      }
      http.get(`/places/${this.place.id_place}/locations`).then((response) => {
        this.locations = response.data || [];
      }).catch(() => {
        this.locations = [];
      });
    },
    getCurrentLocationDisplay() {
      if (this.form.id_place_location === '') {
        return 'Selecione a unidade';
      }
      if (this.form.id_place_location === null) {
        return this.place?.place_name;
      }
      if (this.form.id_place_location && this.locations) {
        const location = this.locations.find(loc => loc.id_place_location === this.form.id_place_location);
        if (location) {
          return location.location_nickname || location.location_name;
        }
      }
      return this.place?.place_name;
    },
    getLocationTooltip() {
      if (this.form.id_place_location && this.locations) {
        const location = this.locations.find(loc => loc.id_place_location === this.form.id_place_location);
        if (location) {
          let address = location.location_full_address || '';
          if (location.location_address) {
            address = location.location_address;
            if (location.location_addr_numer) {
              address += ', ' + location.location_addr_numer;
            }
            if (location.location_neighborhood) {
              address += ' - ' + location.location_neighborhood;
            }
            if (location.city?.city_name) {
              address += ', ' + location.city.city_name;
            }
          }
          return address || (location.location_nickname || location.location_name);
        }
      }
      if (this.place) {
        return this.place.place_full_address || this.place.place_name || 'Local Principal';
      }
      return 'Local Principal';
    },
    onTimeSelected(event) {
      const selectedTime = event.target.value;
      const selectedTimeOption = this.timesAvailabilityToSchedule.find(time => time.available_time === selectedTime);
      if (selectedTimeOption) {
        this.form.id_place_location = selectedTimeOption.id_place_location || null;
      }
    },
    selectLocation(locationId) {
      this.form.id_place_location = locationId;
      this.$nextTick(() => {
        const dropdownElement = document.getElementById('locationDropdownBtn');
        if (dropdownElement) {
          const dropdown = bootstrap.Dropdown.getInstance(dropdownElement);
          if (dropdown) {
            dropdown.hide();
          }
        }
      });
    },
    resetForm() {
      this.patient_last_schedule = null;
      this.isProgramMode = false;
      this.showProgramView = false;
      this.form = {
        sched_by: 'PL',
        sched_date: '',
        sched_time: '',
        sched_patient_name: '',
        sched_patient_cpf: '',
        sched_patient_phone: '',
        sched_patient_birthdate: '',
        id_patient: null,
        sched_obs: '',
        id_avail: '',
        id_insurance: '',
        id_paymeth: '',
        id_prof: this.userAuth.id_prof ?? '',
        id_spec: '',
        id_sched: null,
        id_place_location: null,
        sched_is_fitted: false,
        sched_type: 'NV',
        avail_online: false,
        participants: [],
        is_recurrence: false,
        recurrence: {
          tp_recurrence: null,
          frequency: 'daily',
          tp_end: 'number',
          days_of_week: [],
          end_date: null,
          interval: 1,
          max_occurrences: 1,
        },
      };

      this.datesAvailabilityToSchedule = [];
      this.timesAvailabilityToSchedule = [];

      // Limpar dados relacionados a guias e NFSe
      this.scheduleGuide = null;
      this.scheduleNfse = null;

      if (this.form.id_prof) {
        this.onChangeProf(this.form.id_prof);
      }
    },
    onClickSearchedPatient(patient) {
      if (patient.patient_name)
        this.form.sched_patient_name = patient.patient_name;
      Object.assign(this.form, patientIdentity(patient));
      if (patient.document_type) this.form.sched_patient_cpf = null;
      else if (patient.patient_cpf)
        this.form.sched_patient_cpf = patient.patient_cpf;
      if (patient.patient_phone)
        this.form.sched_patient_phone = patient.patient_phone;
      if (patient.patient_birthdate_formatted)
        this.form.sched_patient_birthdate = patient.patient_birthdate_formatted;
      if (patient.id_patient)
        this.form.id_patient = patient.id_patient;
      // Priorizar o primeiro convênio ativo válido, senão usar id_insurance_last
      let selectedInsuranceId = null;
      
      if (patient.id_insurance_active) {
        // Usar o primeiro convênio ativo válido
        selectedInsuranceId = patient.id_insurance_active;
      } else if (patient.id_insurance_last) {
        // Fallback: usar o último convênio usado
        selectedInsuranceId = patient.id_insurance_last;
      }
      
      if (selectedInsuranceId) {
        let exists = this.insurances.some(insurance => insurance.id_insurance === selectedInsuranceId);
        if (exists) {
          this.form.id_insurance = selectedInsuranceId;
        }
      }
      if (patient.patient_last_schedule)
        this.patient_last_schedule = patient.patient_last_schedule;
    },
    toggleModal() {
      this.uniqueKey = Date.now();
      let modal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#kt_modal_event'), {
        backdrop: 'static',
        keyboard: false,
        focus: false,
      });
      this.rescheduling = false;
      modal.toggle();
    },
    showModal() {
      this.uniqueKey = Date.now();
      let modal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#kt_modal_event'), {
        backdrop: 'static',
        keyboard: false,
        focus: false,
      });
      this.rescheduling = false;
      modal.show();
    },
    openModalEditPatient() {
      if (!this.currentPatientId || !this.place?.id_place) return;
      http.get(`/places/${this.place.id_place}/patients/${this.currentPatientId}`)
        .then((response) => {
          Modal.hide('#kt_modal_event');
          this.$nextTick(() => {
            this.currentPatientData = response.data;
            this.isEditPatientModalOpen = true;
          });
        })
        .catch((e) => {
          Alert.toastError(e.response?.data?.message ?? e.response?.data ?? 'Erro ao carregar paciente.');
        });
    },
    onCloseModalEditPatient() {
      this.isEditPatientModalOpen = false;
      this.currentPatientData = null;
      const el = document.querySelector('#kt_modal_event');
      if (el) {
        bootstrap.Modal.getOrCreateInstance(el).show();
      }
    },
    onPatientUpdated() {
      if (!this.currentPatientId) return;
      http.get(`/places/${this.place.id_place}/patients/${this.currentPatientId}`)
        .then((response) => {
          const p = response.data;
          this.form.sched_patient_name = p.patient_name ?? this.form.sched_patient_name;
          this.form.sched_patient_cpf = p.patient_cpf ?? this.form.sched_patient_cpf;
          this.form.sched_patient_phone = p.patient_phone ?? this.form.sched_patient_phone;
          this.form.sched_patient_birthdate = p.patient_birthdate
            ? moment(p.patient_birthdate).format('DD/MM/YYYY')
            : this.form.sched_patient_birthdate;
          this.onCloseModalEditPatient();
        })
        .catch(() => {
          this.onCloseModalEditPatient();
        });
    },
    canGenerateNfse() {
      if (!this.scheduleEdit?.id_paymeth) {
        return false;
      }

      let paymentMethod = this.paymentMethods.find(p => p.id_paymeth === this.scheduleEdit.id_paymeth);

      if (paymentMethod?.is_insurance) {
        return false;
      }

      return ['FI', 'AR', 'AG', 'CO'].includes(this.scheduleEdit?.sched_status);
    },
    canGenerateGuide() {
      if (!this.allowInsurance()) {
        return false;
      }

      return ['FI', 'AR', 'CO', 'AG'].includes(this.scheduleEdit?.sched_status);
    },
    canReopenGuidePix() {
      return this.scheduleGuide?.guide_charge_payment_method === 'pix'
        && this.scheduleGuide?.card_transaction?.pix_code
        && !['S', 'C'].includes(this.scheduleGuide?.card_transaction?.status);
    },
    canOpenGuideBankSlip() {
      return this.scheduleGuide?.guide_charge_payment_method === 'bank_slip'
        && this.scheduleGuide?.card_transaction?.boleto_url
        && !['S', 'C'].includes(this.scheduleGuide?.card_transaction?.status);
    },
    canCancelGuide() {
      return this.scheduleGuide?.status !== 'cancelled'
        && this.scheduleGuide?.card_transaction?.status !== 'S'
        && !this.scheduleGuide?.id_batch_receipt
        && !this.scheduleGuide?.id_batch_payment;
    },
    generateNfse() {
      if (this.generatingNfse) return;

      Modal.toggle('#kt_modal_event');
      this.$nextTick(() => {
        this.$refs.modalNfseConfirmation.open(this.scheduleEdit);
      });
    },
    generateGuide() {
      if (this.generatingGuide) return;

      Modal.toggle('#kt_modal_event');
      this.$nextTick(() => {
        this.$refs.modalTissGuideConfirmation.open(this.scheduleEdit);
      });
    },
    onNfseConfirmed(nfse) {
      if (this.scheduleEdit) {
        this.scheduleEdit.has_nfse = true;
        this.scheduleNfse = nfse;
      }

      this.$nextTick(() => {
        Modal.toggle('#kt_modal_event');
      });
    },
    onNfseCancelled() {
      this.$nextTick(() => {
        Modal.toggle('#kt_modal_event');
      });
    },
    onGuideConfirmed(guide) {
      if (this.scheduleEdit) {
        this.scheduleEdit.has_tiss_guide = true;
        this.scheduleGuide = guide;
      }
    },
    onGuideCancelled() {
      this.$nextTick(() => {
        Modal.toggle('#kt_modal_event');
      });
    },
    async loadScheduleNfse() {
      if (!this.scheduleEdit?.has_nfse || !this.scheduleEdit?.id_sched) {
        this.scheduleNfse = null;
        return;
      }

      try {
        const response = await http.get(`/places/${this.place.id_place}/nfse?id_sched=${this.scheduleEdit.id_sched}`);
        const nfses = response.data.data;
        this.scheduleNfse = nfses.length > 0 ? nfses[0] : null;
      } catch (e) {
        console.error('Erro ao carregar NFSe:', e);
        this.scheduleNfse = null;
      }
    },
    async loadScheduleGuide() {
      if (!this.scheduleEdit?.id_sched) {
        this.scheduleGuide = null;
        return;
      }

      try {
        const response = await http.get(`/places/${this.place.id_place}/tiss-guides?id_sched=${this.scheduleEdit.id_sched}&guide_type=CONSULTA`);
        const guides = response.data.data;
        this.scheduleGuide = guides.length > 0 ? guides[0] : null;
      } catch (e) {
        console.error('Erro ao carregar guia:', e);
        this.scheduleGuide = null;
      }
    },
    async openDanfse() {
      if (!this.scheduleNfse) return;

      Loader.show('Gerando DANFSE', 'Aguarde...');
      try {
        const response = await http.get(
          `/places/${this.place.id_place}/nfse/${this.scheduleNfse.id_nfse}/danfse`,
          { responseType: 'blob' }
        );

        Download.openPdf(response.data);
      } catch (e) {
        Alert.toastError('Erro ao abrir DANFSE.');
      } finally {
        Loader.close();
      }
    },
    async downloadDanfse() {
      if (!this.scheduleNfse) return;

      Loader.show('Gerando DANFSE', 'Aguarde...');
      try {
        const response = await http.get(
          `/places/${this.place.id_place}/nfse/${this.scheduleNfse.id_nfse}/danfse`,
          { responseType: 'blob' }
        );

        Download.downloadFile(
          response.data,
          `danfse_${this.scheduleNfse.nfse_number || this.scheduleNfse.id_nfse}.pdf`,
          'application/pdf'
        );
      } catch (e) {
        Alert.toastError('Erro ao baixar DANFSE.');
      } finally {
        Loader.close();
      }
    },
    showEmailModal() {
      if (!this.scheduleNfse) return;

      this.emailToSend = this.scheduleNfse.nfse_taker_email || '';

      this.$nextTick(() => {
        Swal.fire({
          title: 'Enviar DANFSE por e-mail',
          html: `
            <div class="mb-3">
              <label for="swal-email" class="form-label">E-mail:</label>
              <input type="email" id="swal-email" class="form-control" value="${this.emailToSend}" placeholder="email@exemplo.com">
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: 'Enviar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#780f5a',
          preConfirm: () => {
            const email = document.getElementById('swal-email').value;
            if (!email) {
              Swal.showValidationMessage('E-mail é obrigatório');
              return false;
            }
            return email;
          }
        }).then((result) => {
          if (result.isConfirmed) {
            this.sendDanfseByEmail(result.value);
          }
        });
      });
    },
    async sendDanfseByEmail(email) {
      if (!this.scheduleNfse) return;

      this.loadingNfseActions = true;
      Loader.show('Enviando e-mail', 'Aguarde...');

      try {
        await http.post(
          `/places/${this.place.id_place}/nfse/${this.scheduleNfse.id_nfse}/danfse/send-email`,
          { email }
        );

        Alert.toastSuccess('DANFSE enviada por e-mail com sucesso!');
      } catch (e) {
        Alert.toastError(e.response?.data?.message || 'Erro ao enviar e-mail.');
      } finally {
        this.loadingNfseActions = false;
        Loader.close();
      }
    },
    async openGuidePdf() {
      if (!this.scheduleGuide) return;

      this.loadingGuideActions = true;
      Loader.show('Gerando PDF da Guia', 'Aguarde...');
      try {
        const response = await http.get(
          `/places/${this.place.id_place}/tiss-guides/${this.scheduleGuide.id_tiss_guide}/pdf`,
          { responseType: 'blob' }
        );

        Download.openPdf(response.data);
      } catch (e) {
        Alert.toastError('Erro ao abrir PDF da guia.');
      } finally {
        this.loadingGuideActions = false;
        Loader.close();
      }
    },
    openGuidePixCharge() {
      const charge = this.scheduleGuide?.card_transaction;
      if (!charge?.pix_code) return;

      this.pixModalData = {
        pix_code: charge.pix_code,
        qr_code_base64: charge.pix_qrcode_img,
        payment_id: charge.id_card_trans,
        expires_at: charge.expires_at || charge.pix_expires_at || null,
      };

      this.$nextTick(() => {
        this.$refs.pixPaymentModal?.open();
      });
    },
    async openGuideBankSlip() {
      if (!this.scheduleGuide) return;

      this.loadingGuideActions = true;
      Loader.show('Abrindo boleto', 'Aguarde...');
      try {
        const response = await http.get(
          `/places/${this.place.id_place}/tiss-guides/${this.scheduleGuide.id_tiss_guide}/charge/bank-slip`,
          { responseType: 'blob' }
        );

        Download.openPdf(response.data);
      } catch (e) {
        Alert.toastError(e.response?.data?.message || 'Erro ao abrir boleto da guia.');
      } finally {
        this.loadingGuideActions = false;
        Loader.close();
      }
    },
    cancelGuide() {
      if (!this.scheduleGuide) return;

      Swal.fire({
        title: 'Cancelar guia',
        text: `Tem certeza que deseja cancelar a guia ${this.scheduleGuide.guide_number}?`,
        input: 'text',
        inputLabel: 'Motivo do cancelamento (opcional)',
        showCancelButton: true,
        confirmButtonText: 'Cancelar guia',
        cancelButtonText: 'Voltar',
        confirmButtonColor: '#d33',
      }).then(async (result) => {
        if (!result.isConfirmed) return;

        this.loadingGuideActions = true;
        Loader.show('Cancelando guia', 'Aguarde...');

        try {
          const response = await http.post(
            `/places/${this.place.id_place}/tiss-guides/${this.scheduleGuide.id_tiss_guide}/cancel`,
            { reason: result.value || null }
          );

          this.scheduleEdit.has_tiss_guide = true;
          this.scheduleGuide = response.data.guide;
          Alert.toastSuccess('Guia cancelada com sucesso.');
        } catch (e) {
          Alert.toastError(e.response?.data?.message || 'Erro ao cancelar guia.');
        } finally {
          this.loadingGuideActions = false;
          Loader.close();
        }
      });
    },
  }
}
</script>

<style scoped>
/* Estilos para o dropdown de locations */
.dropdown-menu {
  border: 1px solid #e0e0e0;
}

.dropdown-item {
  transition: all 0.2s ease;
  border: none;
  background: transparent;
}

.dropdown-item:hover {
  background-color: #f8f9fa !important;
  color: inherit;
}

.dropdown-item.bg-primary.bg-opacity-10 {
  background-color: rgba(13, 110, 253, 0.1) !important;
}

.dropdown-item.bg-primary.bg-opacity-10:hover {
  background-color: rgba(13, 110, 253, 0.15) !important;
}

:deep(.p-dropdown-panel) {
  z-index: 1100 !important;
}

.dropdown-item .bi-check-circle-fill {
  font-size: 1.1rem;
  margin-top: 0.1rem;
}

.dropdown-item .text-dark {
  color: #212529 !important;
}

.dropdown-item .text-muted {
  color: #6c757d !important;
}
</style>

<style scoped>
.schedule-editor-modal {
  --sw-brand: #780f5a;
  --sw-line: #e4e6ef;
  --sw-muted: #7e8299;
  --sw-ink: #181c32;
  --sw-soft: #f8f5f7;
  color: var(--sw-ink);
}
.schedule-editor-modal__dialog { width: calc(100% - 2.5rem); max-width: 1140px; margin: 1.25rem auto; min-height: calc(100% - 2.5rem); }
.schedule-editor-modal .modal-content { border: 1px solid var(--sw-line); border-radius: .85rem; box-shadow: 0 18px 48px rgba(24,28,50,.18); max-height: calc(100dvh - 2.5rem); overflow: hidden; }
:global(body:has(.schedule-editor-modal.show) > .modal-backdrop) { background: #181c32; opacity: .38; }
.schedule-editor-modal__header { padding: 1rem 1.25rem; gap: 1rem; border-bottom: 1px solid var(--sw-line); }
.schedule-editor-modal__header h2 { display: flex; align-items: center; flex-wrap: wrap; gap: .6rem; margin: 0; font-size: 1.1rem; font-weight: 800; color: var(--sw-ink); }
.schedule-editor-modal__header h2 > span { margin: 0 !important; }
.schedule-editor-modal__header h2 > span:last-child:empty { display: none; }
.schedule-editor-modal__header .form-check-label { font-size: .8rem; font-weight: 600; color: var(--sw-muted); }
.schedule-editor-modal__close { appearance: none; flex: 0 0 2.1rem; height: 2.1rem; display: inline-flex; align-items: center; justify-content: center; background: #fff; border: 1px solid var(--sw-line); border-radius: .5rem; color: var(--sw-muted); cursor: pointer; }
.schedule-editor-modal__close:hover { color: var(--sw-brand); border-color: var(--sw-brand); background: var(--sw-soft); }
.schedule-editor-modal .modal-body { padding: 0 1.25rem; overflow-y: auto; overscroll-behavior: contain; }
.schedule-editor-modal .nav-tabs { gap: .35rem; padding: .7rem 0; border-bottom: 1px solid var(--sw-line); }
.schedule-editor-modal .nav-tabs .nav-link { padding: .45rem .85rem; border: 1px solid transparent; border-radius: .5rem; font-size: .85rem; font-weight: 600; color: var(--sw-muted); margin: 0; }
.schedule-editor-modal .nav-tabs .nav-link.active { border-color: var(--sw-brand); color: var(--sw-brand); background: var(--sw-soft); }
.schedule-editor { display: grid; grid-template-columns: minmax(0, 1fr) 340px; align-items: start; gap: 1rem 1.25rem; padding-top: 1rem; }
.schedule-editor__main { min-width: 0; }
.schedule-editor__section-title { display: flex; align-items: center; gap: .5rem; font-size: .85rem; font-weight: 800; color: var(--sw-ink); margin-bottom: .15rem; }
.schedule-editor__section-title i { color: var(--sw-brand); font-size: .95rem; }
.schedule-editor__section-title--divided { border-top: 1px solid var(--sw-line); padding-top: .55rem; margin-top: .65rem; }
.schedule-editor-modal :deep(.form-label), .schedule-editor-modal :deep(label.fs-6) { color: var(--sw-muted); font-size: .75rem !important; font-weight: 700 !important; margin-bottom: .4rem !important; }
.schedule-editor-modal :deep(.form-control), .schedule-editor-modal :deep(.form-select) { min-height: 2.4rem; font-size: .9rem; border-radius: .5rem; }
.schedule-editor-modal :deep(.form-control-solid) { background-color: #f5f6f8; }
.schedule-editor-modal :deep(.form-check-input:checked) { background-color: var(--sw-brand); border-color: var(--sw-brand); }
.schedule-editor-modal :deep(.form-control:focus) { border-color: var(--sw-brand); box-shadow: none; }
.schedule-editor-modal .fv-row { margin-bottom: 0; }
.schedule-editor__availability { min-width: 0; padding: 1rem; border: 1px solid var(--sw-line); border-radius: .85rem; background: #fff; }
.schedule-editor__availability > h3 { margin: 0 0 1rem; }
.schedule-editor__date-fields > [class*="col-md-"] { width: 100%; }
.schedule-editor__availability :deep(.p-datepicker) { border: 0; padding: 0; width: 100%; min-width: 0; }
.schedule-editor__availability :deep(.p-calendar) { width: 100%; }
.schedule-editor__availability :deep(.p-datepicker-header) { padding: .2rem 0; }
.schedule-editor__availability :deep(.p-datepicker table td) { padding: .15rem; }
.schedule-editor__availability :deep(.p-datepicker table td > span) { width: 2rem; height: 2rem; }
.schedule-editor__availability :deep(.p-datepicker table td > span > div > div) { width: 1.8rem !important; height: 1.8rem; justify-content: center; }
.schedule-editor__availability .flex-auto > .col-md-6 { width: 100%; }
.schedule-editor__time-heading { display: flex; align-items: center; justify-content: space-between; gap: .75rem; margin-bottom: .5rem; }
.schedule-editor__time-heading > label { flex-shrink: 0; font-size: .8rem; cursor: pointer; }
.schedule-editor__empty-times { margin: .5rem 0 0; color: var(--sw-muted); font-size: .8rem; line-height: 1.5; }
.schedule-editor__availability :deep(.p-datepicker table td > span.p-highlight) { color: var(--sw-brand); background: var(--sw-soft); outline: 1px solid var(--sw-brand); }
.schedule-editor__availability select[size] { height: 8rem; padding: .35rem; border: 1px solid var(--sw-line); }
.schedule-editor__availability select[size] option { padding: .35rem .65rem; border-radius: .4rem; }
.schedule-editor__waiting { margin-top: 0; margin-bottom: 0; padding-top: .5rem; }
.schedule-editor__waiting > hr { display: none; }
.schedule-editor-modal :deep(.schedule-editor__footer) { display: flex; flex-wrap: wrap; grid-column: 1 / -1; position: sticky; bottom: 0; z-index: 3; justify-content: flex-end; gap: .5rem; padding: .85rem 0 1rem; background: #fff; border-top: 1px solid var(--sw-line); margin-top: 0; }
.schedule-editor-modal :deep(.schedule-editor__button) { appearance: none; display: inline-flex; align-items: center; justify-content: center; min-height: 2.4rem; padding: .45rem .9rem; border: 1px solid var(--sw-line); border-radius: .5rem; background: #fff; color: var(--sw-ink); font-size: .92rem; font-weight: 600; cursor: pointer; box-shadow: none; }
.schedule-editor-modal :deep(.schedule-editor__button:hover) { border-color: var(--sw-brand); color: var(--sw-brand); background: var(--sw-soft); }
.schedule-editor-modal :deep(.schedule-editor__button--primary) { border-color: var(--sw-brand); background: var(--sw-brand); color: #fff; }
.schedule-editor-modal :deep(.schedule-editor__button--primary:hover) { border-color: #65104c; background: #65104c; color: #fff; }
.schedule-editor-modal :deep(.schedule-editor__button:disabled) { opacity: .6; cursor: wait; }
.schedule-editor-modal :deep(.btn:not(.btn-link):not(.btn-check + label)) { border-radius: .5rem; font-size: .85rem; }
@media (max-width: 991px) {
  .schedule-editor { grid-template-columns: minmax(0, 1fr); }
  .schedule-editor-modal__dialog { width: calc(100% - 1.25rem); margin: .625rem auto; min-height: calc(100% - 1.25rem); }
  .schedule-editor-modal .modal-content { max-height: calc(100dvh - 1.25rem); }
  .schedule-editor-modal__header { padding: .85rem 1rem; }
  .schedule-editor-modal .modal-body { padding: 0 1rem; }
}
</style>

<style scoped>
.schedule-editor__mode { display: flex; align-items: center; justify-content: space-between; gap: .75rem; padding: .8rem 1.25rem; border-bottom: 1px solid var(--sw-line); background: #fff; }
.schedule-editor__mode-label { color: var(--sw-muted); font-size: .8rem; font-weight: 700; }
.schedule-editor__mode-options { display: inline-flex; gap: .3rem; padding: .25rem; border: 1px solid var(--sw-line); border-radius: .65rem; background: var(--sw-soft); }
.schedule-editor__mode-option { appearance: none; display: inline-flex; align-items: center; justify-content: center; gap: .5rem; min-height: 2.4rem; padding: .45rem .9rem; border: 1px solid transparent; border-radius: .5rem; background: transparent; color: var(--sw-ink); font-size: .92rem; font-weight: 600; cursor: pointer; }
.schedule-editor__mode-option i { color: inherit; }
.schedule-editor__mode-option:hover { color: var(--sw-brand); border-color: var(--sw-brand); }
.schedule-editor__mode-option.is-active { background: var(--sw-brand); border-color: var(--sw-brand); color: #fff; }
.schedule-editor__mode-option:focus-visible { outline: 2px solid var(--sw-brand); outline-offset: 2px; }
@media (max-width: 575px) {
  .schedule-editor__mode { align-items: stretch; flex-direction: column; padding: .75rem 1rem; gap: .5rem; }
  .schedule-editor__mode-options { display: grid; grid-template-columns: 1fr 1fr; }
  .schedule-editor__mode-option { padding-inline: .5rem; }
}
</style>
